<template>
  <div
    class="ib-grid-view-placeholder-card-wrapper placeholder-card large"
    :class="{'disabled': disabled}"
  >
    <div class="w-100">
      <div class="avatar-placeholder" :class="variant" />
      <div class="stripe-medium" />
      <div class="stripe-small" />
      <div class="stripe-large" />
    </div>
  </div>
</template>

<script>
/** Colors **/
const COLORS = ['blue', 'yellow']

export default {
  name: 'IbGridViewPlaceholderCard',

  props: {
    variant: {
      type: String,
      validator: value => {
        return COLORS.includes(value)
      },
      default: 'blue'
    },

    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.ib-grid-view-placeholder-card-wrapper {
  min-height: 410px;

  &.large {
    position: relative;
    height: auto;
    border-radius: 8px;
    background-color: transparent;
    border: 1px solid rgba($color-text-cement, .15);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .avatar-placeholder {
    display: block;
    margin-right: auto;
    margin-left: auto;
    min-width: 116px;
    max-width: 116px;
    min-height: 116px;
    height: auto;
    border-radius: 50%;
    background-color: rgba($color-text-cement, .05);
    margin-bottom: 22px;

    &.blue {
      border: 1px solid rgba($color-royal-blue, .25);
    }

    &.yellow {
      border: 1px solid rgba($color-yellow, .25);
    }
  }

  .stripe-medium {
    display: block;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    min-height: 22px;
    border-radius: 3px;
    height: auto;
    background-color: rgba($color-text-cement, .1);
  }

  .stripe-small {
    display: block;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
    min-height: 14px;
    border-radius: 3px;
    height: auto;
    background-color: rgba($color-text-cement, .1);
    margin-top: 8px;
  }

  .stripe-large {
    display: block;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    min-height: 27px;
    border-radius: 3px;
    height: auto;
    background-color: rgba($color-text-cement, .1);
    margin-top: 33px;
  }

  &.disabled {
    cursor: not-allowed;
    filter: grayscale(0.7);
  }
}
</style>
